import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Lock, Zap, ShieldCheck, CreditCard } from 'lucide-react';
import { CountdownTimer, CTAButton } from './Shared';
export function FAQSection() {
  const faqs = [{
    q: '¿Cómo recibo el Ciudadanía Pack después de comprar?',
    a: 'Inmediatamente después del pago recibís un email con el enlace de descarga de todos los archivos PDF. El acceso es instantáneo, las 24 horas, los 7 días.'
  }, {
    q: '¿Está en blanco y negro?',
    a: 'Sí. Todo el material está diseñado específicamente para impresión en blanco y negro, optimizado para fotocopiadora escolar. Sin degradados ni fondos que consuman tóner.'
  }, {
    q: '¿Los 6 bonus están en todas las ofertas?',
    a: 'Sí. Los 6 bonus estratégicos están incluidos en todas las opciones de compra sin costo adicional.'
  }, {
    q: '¿Los Ebooks Élite están en todas las ofertas?',
    a: 'Los Ebooks Élite (Planificaciones Anuales y Proyectos ESI + EAI) están incluidos únicamente en el Pack Completo de $27.990 ARS.'
  }, {
    q: '¿Está actualizado al currículo vigente?',
    a: 'Sí. Todo el material está alineado al diseño curricular 2026 de Construcción de Ciudadanía para el nivel secundario.'
  }, {
    q: '¿Qué pasa si no tengo internet en la escuela?',
    a: 'El material es 100% PDF descargable. Una vez que lo descargás, funciona sin internet. Podés imprimirlo, guardarlo en el celular o en una USB y usarlo en cualquier momento.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total. Si no estás satisfecho por cualquier motivo, te devolvemos el 100% del dinero sin preguntas ni formularios.'
  }, {
    q: '¿Qué diferencia tiene con otros packs que vi?',
    a: 'Ningún otro recurso de Ciudadanía en Argentina resuelve en un solo pack las actividades del aula, las planificaciones anuales Y los proyectos ESI + EAI obligatorios. Es la solución más completa del mercado.'
  }, {
    q: '¿Puedo comprar solo los tomos de un año específico?',
    a: 'Por el momento el pack se vende completo (los 6 tomos del 1° al 3° año) para garantizar la secuencia didáctica completa. Es la versión más inteligente de implementar el material.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-white border-t border-slate-100" data-id="element-38">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-39">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-slate-900 mb-12" data-id="element-40">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-41">
          {faqs.map((faq, i) => <div key={i} className="border border-slate-200 rounded-xl overflow-hidden" data-id="element-42">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-5 text-left bg-slate-50 hover:bg-slate-100 transition-colors" data-id="element-43">
                <span className="font-bold text-slate-900 pr-4" data-id="element-44">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-slate-500 transition-transform ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-45" />
              </button>
              <AnimatePresence data-id="element-46">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} className="overflow-hidden bg-white" data-id="element-47">
                    <div className="p-5 text-slate-600 border-t border-slate-100" data-id="element-48">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}
export function FinalCTA() {
  return <section className="py-20 bg-brand-950 text-white relative overflow-hidden" data-id="element-49">
      <div className="absolute inset-0 bg-gradient-to-b from-brand-900 to-brand-950" data-id="element-50"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-brand-800 rounded-full blur-[100px] opacity-30" data-id="element-51"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10 text-center" data-id="element-52">
        <div className="inline-block bg-brand-900 border border-brand-800 text-brand-200 px-4 py-1.5 rounded-full font-bold text-sm mb-8" data-id="element-53">
          📚 CIUDADANÍA PACK
        </div>

        <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-54">
          El próximo domingo podés seguir
          <br className="hidden md:block" data-id="element-55" /> armando actividades en Google.
        </h2>
        <h3 className="text-2xl md:text-3xl text-amber-400 font-bold mb-12" data-id="element-56">
          O podés tener todo resuelto desde hoy.
        </h3>

        <div className="flex justify-center mb-12" data-id="element-57">
          <CountdownTimer data-id="element-58" />
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto mb-12" data-id="element-59">
          <div className="bg-brand-900/50 border border-brand-800 rounded-2xl p-6 flex flex-col justify-between" data-id="element-60">
            <div data-id="element-61">
              <div className="text-brand-300 font-bold mb-2" data-id="element-62">📗 SECUNDARIA</div>
              <div className="text-3xl font-bold text-white mb-6" data-id="element-63">
                $18.990 ARS
              </div>
            </div>
            <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} className="w-full py-3 rounded-xl border-2 border-brand-500 text-brand-300 hover:bg-brand-800 font-bold transition-colors" data-id="element-64">
              → QUIERO SECUNDARIA
            </button>
          </div>

          <div className="bg-gradient-to-b from-amber-500 to-amber-600 rounded-2xl p-1 shadow-2xl transform md:-translate-y-2" data-id="element-65">
            <div className="bg-brand-900 rounded-xl p-6 h-full flex flex-col justify-between" data-id="element-66">
              <div data-id="element-67">
                <div className="text-amber-400 font-bold mb-2" data-id="element-68">
                  🏆 PACK COMPLETO ⭐
                </div>
                <div className="text-4xl font-black text-white mb-6" data-id="element-69">
                  $27.990 ARS
                </div>
              </div>
              <CTAButton className="w-full" data-id="element-70">
                → QUIERO MI CIUDADANÍA PACK COMPLETO
              </CTAButton>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-brand-300 font-medium" data-id="element-71">
          <span className="flex items-center gap-1.5" data-id="element-72">
            <Lock className="w-4 h-4 text-green-400" data-id="element-73" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-74">
            <Zap className="w-4 h-4 text-amber-400" data-id="element-75" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-1.5" data-id="element-76">
            <ShieldCheck className="w-4 h-4 text-green-400" data-id="element-77" /> Garantía 7 días
            sin preguntas
          </span>
          <span className="flex items-center gap-1.5" data-id="element-78">
            <CreditCard className="w-4 h-4 text-sky-400" data-id="element-79" /> Mercado Pago |
            Tarjeta de crédito
          </span>
        </div>
      </div>
    </section>;
}
export function Footer() {
  return <footer className="bg-slate-950 text-slate-400 py-12 border-t border-slate-900" data-id="element-80">
      <div className="container mx-auto px-4 text-center" data-id="element-81">
        <div className="text-2xl font-display font-bold text-white mb-4" data-id="element-82">
          📚 CIUDADANÍA PACK
        </div>
        <p className="text-slate-300 font-medium mb-2" data-id="element-83">
          El sistema de planificación N°1 para docentes de Construcción de
          Ciudadanía de secundaria en el Mundo
        </p>
        <p className="text-sm mb-8" data-id="element-84">
          Porque enseñar Ciudadanía no debería costarte todos los domingos del
          año.
        </p>
        <div className="text-xs text-slate-600" data-id="element-85">
          © CIUDADANÍA PACK — Profe Listo
          <br data-id="element-86" />
          Todos los derechos reservados
        </div>
      </div>
    </footer>;
}